import React from 'react'
import { Box } from '@material-ui/core'
import { useStyles } from './styles'
import { ImagesComponent } from '../image-component'

export const CommentCardBody = ({ comment, isCommentInEditMode }) => {
    const classes = useStyles()

    if (isCommentInEditMode) return null

    return (
        <Box className={classes.commentContentSection}>
            <Box
                style={{
                    whiteSpace: 'pre-line'
                }}>
                {comment.text}
            </Box>
            <ImagesComponent commentId={comment?.id} />
        </Box>
    )
}
